import { BudgetCategory } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateBudgetCategory {
    constructor(
        public name: BudgetCategory["name"],
        public budget: BudgetCategory["budget"],
    ) {}
}
